
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.32.351C18.35.614 15.678 1.85 13.505 3.96c-2.257 2.192-3.55 4.909-3.86 8.106-.227 2.351.205 4.652 1.281 6.827.847 1.71 2.219 3.393 3.648 4.475l.597.452-.25.098c-.138.054-.395.15-.57.213-1.168.422-3.007 1.383-4.284 2.24-4.336 2.906-7.661 7.443-9.05 12.35-.518 1.83-.875 4.12-.877 5.634l-.001.589h3.458l.102-1.296c.368-4.671 2.232-8.751 5.483-12.003 5.172-5.172 12.633-6.877 19.55-4.469 4.815 1.677 8.971 5.544 11 10.235.879 2.028 1.351 3.955 1.531 6.239l.102 1.297 1.75-.023 1.752-.024.025-.77c.014-.425-.007-.752-.047-.727-.04.025-.12-.433-.178-1.018-.478-4.839-2.79-9.614-6.401-13.226-2.186-2.186-5.116-4.11-7.655-5.028-.176-.063-.432-.16-.57-.213l-.25-.098.597-.452c3.401-2.575 5.342-7.025 4.928-11.302-.309-3.197-1.602-5.914-3.86-8.106-2.22-2.157-4.808-3.334-7.94-3.611-1.082-.096-1.08-.096-2.196.003zM20.85 3.88c-1.939.352-3.563 1.214-5.008 2.659-.9.9-1.296 1.448-1.833 2.535-1.964 3.977-.765 8.94 2.801 11.602 4.83 3.605 11.607 1.925 14.185-3.518 1.414-2.985 1.149-6.423-.716-9.283-.428-.656-1.854-2.077-2.52-2.512a10.026 10.026 0 00-3.687-1.486c-.838-.15-2.39-.148-3.222.003zM.17 44.2c0 .432.014.62.032.417a5.666 5.666 0 000-.785c-.017-.23-.032-.064-.032.368z","fill":"url(#paint0_linear_1678_2124)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1678_2124","x1":"22.517","y1":".276","x2":"22.517","y2":"44.946","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#29F39B"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#02A1F9"}})])])])
          )
        }
      }
    